import TrastpilotStars from 'components/TrastpilotStars';
import TrastpilotLogo from 'components/TrastLogo';
import './styles.scss'
import { Link } from 'react-router-dom';


//Type: green/outline

const HeroTrastpilot = ({ type = "green" }) => {
    return (
        <Link to={'https://www.trustpilot.com/review/pingproxies.com'} target='_blank' className={`body3 hero-trastpilot hero-trastpilot--${type}`}>
            <span>Excellent</span>
            <TrastpilotStars />
            {/* <div className='hero-trastpilot__reviews'>
                {reviews}
                <span>reviews on</span>
            </div> */}
            <TrastpilotLogo type={type} />
        </Link>
    );
}

export default HeroTrastpilot;